import { closeDialog, ModalHandler } from '../components/modals';

export function formHandler(options) {
  return {
    form: { ...options.fields },
    originalFields: { ...options.fields },
    successModal: options.successModal ?? false,
    errors: {},
    async submitForm() {
      try {
        const response = await fetch(options.url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify(this.form),
        });

        const data = await response.json();

        if (!response.ok) {
          this.errors = data.errors || {};
        } else {
          Object.keys(this.form).forEach((key) => {
            this.form[key] = this.originalFields[key];
          });

          this.errors = {};
          this.resetForm();

          if (this.$root.closest('dialog')) {
            closeDialog(this.$root.closest('dialog'));
          }

          if (this.successModal) {
            ModalHandler(this.successModal);
          }
        }
      } catch (e) {
        console.error('Помилка з’єднання з сервером.');
      }
    },

    resetForm() {
      this.form.phone = '';

      const telInput = document.querySelector('input[type="tel"]');
      if (telInput) {
        telInput.value = '';

        const itiInstance = telInput?.__tti || telInput?.__x?.$data?.iti;
        if (itiInstance?.setNumber) {
          itiInstance.setNumber('');
        }
      }
    }
  };
}
